import { HandArrowUp } from "@phosphor-icons/react";

import Switch from "common/components/ui/Switch";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import ActionDelay from "./ActionDelay";
import SectionHeading from "./SectionHeading";

export default function EndorseSkill({
  settings: { isEnabled, delay },
  updateSettings,
  isDisabled,
  hasMessageSequence,
}: {
  settings: { isEnabled: boolean; delay: number };
  updateSettings: (isEnabled: boolean, delay: number) => void;
  isDisabled: boolean;
  hasMessageSequence: boolean;
}) {
  const isDesktop = useTwBreakpoint("lg");

  return (
    <div className="flex flex-col gap-y-2 lg:gap-y-3">
      <div className="flex flex-row items-center justify-between gap-3">
        <SectionHeading
          title="Endorse a skill"
          description="Ping your target by endorsing one of their skills"
          icon={<HandArrowUp weight="fill" />}
          shouldShowMobileTooltip
        />
        <Switch
          checked={isEnabled}
          onCheckedChange={(checked) => {
            // if delay is not set, set it to 2 days
            updateSettings(checked, delay || 172800000);
          }}
          disabled={isDisabled}
        />
      </div>
      {isEnabled && (
        <ActionDelay
          delay={delay}
          onDelayChange={(newDelay) => {
            updateSettings(isEnabled, newDelay);
          }}
          isDisabled={isDisabled}
          labels={{
            action: isDesktop ? "Endorse a skill" : "your endorsement",
            after: hasMessageSequence
              ? "message sequence ending"
              : "connecting",
          }}
        />
      )}
    </div>
  );
}
